import baseScmService from 'services/baseScmService';

const menteeModuleService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getMenteeModules: build.query({
      query: (email) => ({
        method: 'GET',
        url: '/mentee-modules/',
        params: { email },
      }),
      providesTags: (result, error) => {
        const menteeModulesTags = result?.data?.map((mm) => ({
          type: 'MenteeModule',
          id: mm.id,
        }));
        return error ? [] : menteeModulesTags;
      },
    }),
    updateMenteeModuleStatus: build.mutation({
      query: (menteeModule) => ({
        method: 'PUT',
        url: `/mentee-modules/${menteeModule.id}`,
        body: {
          status: menteeModule.updatedStatus,
        },
      }),
      invalidatesTags: (result, error, { id }) => {
        return error ? [] : [{ type: 'MenteeModule', id: id }];
      },
    }),
    bulkReorderMenteeModules: build.mutation({
      query: (menteeModules) => ({
        method: 'POST',
        url: '/mentee-modules/bulk-reorder',
        body: {
          data: menteeModules,
        },
      }),
      invalidatesTags: (result, error, menteeModules) => {
        const menteeModulesTags = menteeModules?.map((mm) => ({
          type: 'MenteeModule',
          id: mm.id,
        }));
        return error ? [] : menteeModulesTags;
      },
    }),
    addMenteeModule: build.mutation({
      query: ({
        email,
        academyModuleId,
        beforeModuleId,
        interviewRequired,
        skillContestRequired,
      }) => ({
        method: 'POST',
        url: '/mentee-modules/',
        body: {
          email,
          academy_module_id: academyModuleId,
          before_module_id: beforeModuleId,
          interview_required: interviewRequired,
          skill_contest_required: skillContestRequired,
        },
      }),
      invalidatesTags: (result, error, { menteeModules }) => {
        const menteeModulesTags = menteeModules?.map((mm) => ({
          type: 'MenteeModule',
          id: mm.id,
        }));
        return error ? [] : menteeModulesTags;
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMenteeModulesQuery,
  useUpdateMenteeModuleStatusMutation,
  useBulkReorderMenteeModulesMutation,
  useAddMenteeModuleMutation,
} = menteeModuleService;

export default menteeModuleService;
